import ForecastDate from "@/components/master/forecast_date/ForecastDate.vue";
import ForecastDateDetail from "@/components/master/forecast_date/ForecastDateDetail.vue";
import ForecastDateEdit from "@/components/master/forecast_date/ForecastDateEdit.vue";


let routesForecastDate = [
    
    {
        path: '',
        meta: {
          title: "Sales System",
        },
        name: "ForecastDateIndex",
        component: ForecastDate
      },
     
    
      {
        path: 'edit/:id',
        meta: {
          title: "Sales System",
        },
        name: "ForecastDateEdit",
        component: ForecastDateEdit
      },
    
      {
        path: 'detail/:id',
        meta: {
          title: "Sales System",
        },
        name: "ForecastDateDetail",
        component: ForecastDateDetail
      },
    
      
  ]
  
  export default routesForecastDate
  